import { Component, inject } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { PATH_HOME, PATH_ABOUT_US, PATH_RELEASE_PAGES, PATH_RELOAD_PAGES } from '../global';
import { PATH_PATIENTS } from '../patients/patients.global';
import { isKnightmedsCabinetMode } from 'src/environments/deploy_info';
import { PATH_STUDENTS } from '../students/students.global';
import { PATH_MEDICATIONS } from '../medications/medications.global';
import {
  PATH_SETTINGS,
  PATH_SETTINGS_GENERAL,
  PATH_SETTINGS_HELP,
} from '../settings/settings.global';
import { AuthStore } from 'src/app/calvin-emr-shared/state/auth/auth.store';
import { NavBarTemplateComponent } from '../calvin-emr-shared/nav-bar-template/nav-bar-template.component';
import { NavBarButtonComponent } from '../calvin-emr-shared/nav-bar-template/nav-bar-button/nav-bar-button.component';
import { NavBarSplitButtonComponent } from '../calvin-emr-shared/nav-bar-template/nav-bar-split-button/nav-bar-split-button.component';
import { environment } from 'src/environments/environment';
import { CustomerInfo } from 'src/environments/deploy_info';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
  standalone: true,
  imports: [
    NavBarTemplateComponent,
    NavBarButtonComponent,
    NavBarSplitButtonComponent,
    RouterLink,
    RouterOutlet,
  ],
})
export class NavBarComponent {
  // Local constants
  isKnightMedsInstall = isKnightmedsCabinetMode();
  homePath = PATH_HOME;
  patientsPath = PATH_PATIENTS;
  studentsPath = PATH_STUDENTS;
  medicationsPath = PATH_MEDICATIONS;
  aboutUsPath = PATH_ABOUT_US;
  settingsPath = PATH_SETTINGS;
  releasePagesPath = PATH_RELEASE_PAGES;
  reloadPagesPath = PATH_RELOAD_PAGES;

  // Get customer information from the environment, so that
  // the logo, etc. is correct.
  customer: CustomerInfo = environment.customer;

  /**
   * Menu items to display under the "Profile" split button.
   */
  profileItems: MenuItem[] = [
    {
      label: 'Settings',
      icon: 'pi pi-cog',
      command: () => {
        this.navigateToSettingsGeneral();
      },
    },
    {
      label: 'Help',
      icon: 'pi pi-question-circle',
      command: () => {
        this.navigateToSettingsHelp();
      },
    },
    { separator: true },
    {
      label: 'Log Out',
      icon: 'pi pi-sign-out',
      command: () => {
        this.logout();
      },
    },
  ];

  private authStore = inject(AuthStore);
  private router = inject(Router);

  loggedIn = this.authStore.isLoggedIn;
  isAdmin = this.authStore.isAdmin;

  /**
   * Navigates to '/settings/general' path.
   */
  navigateToSettingsGeneral() {
    this.router.navigateByUrl(`${PATH_SETTINGS}/${PATH_SETTINGS_GENERAL}`);
  }

  /**
   * Navigates to '/settings/help' path.
   */
  navigateToSettingsHelp() {
    this.router.navigateByUrl(`${PATH_SETTINGS}/${PATH_SETTINGS_HELP}`);
  }

  /**
   * Calls the Store to log the user out.
   */
  logout() {
    this.authStore.logout();
  }
}
